import {db} from '@src/services/db'
import {useObservable} from "@vueuse/rxjs";
import {liveQuery} from "dexie";
import Contact from "@src/types/Contact";

export function useContacts() {

    function getContactById(id: number | undefined) {
        return useObservable<Contact | undefined>(
            // @ts-ignore
            liveQuery(async () => {
                if (!id) return undefined;
                const contact = await db.contacts
                    .where('costumer_id')
                    .equals(id)
                    .first()
                return contact
            }),
            {
                initialValue: undefined
            }
        )
    }

    function getAllContacts() {
        return useObservable<Contact[]>(
            // @ts-ignore
            liveQuery(async () => {
                const contacts = await db.contacts.toArray();

                return contacts.filter(contact => {
                    if ((contact as any).costumer?.type === 'whatsapp') {
                        return true;
                    }

                    if (!contact.costumer_id && contact.token) {
                        return true;
                    }

                    return false;
                });
            }),
            {
                initialValue: []
            }
        )
    }

    return {
        getContactById,
        getAllContacts
    }
}
